import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBuyerDetails, getGraphData, getPOReport, getPOTableData } from "../api/poPending";

export const fetchBuyerDetails = createAsyncThunk(
  "po/fetchBuyerDetails",
  async (params) =>
    getBuyerDetails(
      params?.division,
      params?.department,
      params?.page,
      params?.limit,
      params?.search
    )
);

export const fetchGraphData = createAsyncThunk(
  "po/fetchGraphData",
  async (params) =>
    getGraphData(
      params?.date,
      params?.aggr,
      params?.countColumn,
      params?.division,
      params?.department,
      params?.buyer,
      params?.location,
      params?.page,
      params?.limit,
      params?.showBOParts,
      params?.fromDate
    )
);

export const fetchPOReport = createAsyncThunk(
  "po/fetchPOReport",
  async (params) =>
    getPOReport(
      params?.date,
      params?.division,
      params?.department,
      params?.buyer,
      params?.location,
      params?.showBOParts,
      params?.fromDate,
      params?.countColumn,
    )
);

export const fetchPOTableData = createAsyncThunk(
  "po/fetchPOTableData",
  async (params) =>
  getPOTableData(
      params?.date,
      params?.division,
      params?.department,
      params?.buyer,
      params?.location,
      params?.page,
      params?.limit,
      params?.showBOParts,
      params?.fromDate,
      params?.countColumn,
    )
);

export const poPendingSlice = createSlice({
  name: "po",
  initialState: {
    buyerDetails: null,
    graphData: null,
    poReport: null,
    poTableData: null,
    loading: false,
    buyerDetailsLoading: false,
  },
  extraReducers: {
    [fetchBuyerDetails.pending]: (state, { payload }) => {
      state.buyerDetailsLoading = true;
    },
    [fetchBuyerDetails.fulfilled]: (state, { payload }) => {
      state.buyerDetails = payload;
      state.buyerDetailsLoading = false;
    },
    [fetchBuyerDetails.rejected]: (state, { payload }) => {
      state.buyerDetailsLoading = false;
    },
    [fetchGraphData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchGraphData.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.graphData = payload;
    },
    [fetchGraphData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchPOReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchPOReport.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.poReport = payload;
    },
    [fetchPOReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchPOTableData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchPOTableData.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.poTableData = payload;
    },
    [fetchPOTableData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default poPendingSlice.reducer;
